import React, { useState } from 'react';
import { Box, Card, Flex, Heading, Text } from 'rebass';
import styled from 'styled-components';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';

const Container = styled(Box)`
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  padding: 48px 6px 0 6px;
`;

const GET_ADMIN_SCHEMA = gql`
  query GetAdminSchema {
    getAdminSchema
  }
`;

const QueryRow = ({ query, types }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const returnType = types[query.namedType];
  if(query.name==='getMemberships'){
    console.log(types)
    console.log(query.namedType)
    console.log(returnType)
  }
  return (
    <Card mb={3} p={'8px 16px'}>
      <Flex flex={1} flexDirection={'column'}>
        <Flex flex={1} onClick={() => setIsExpanded(!isExpanded)} flexDirection={'row'}>
          <Text flex={1} fontWeight={600}>
            {query.name}
          </Text>
        </Flex>
        {isExpanded && (
          <Flex flex={1} flexDirection={'column'} pl={3} style={{ gap: 4 }}>
            {query.args &&
              query.args.length > 0 && (
                <>
                  <Text fontWeight={500} fontSize={'14px'}>
                    Parameters:
                  </Text>
                  <Flex flex={1} flexDirection={'column'} pl={3}>
                    {query.args.map((x) => {
                      return (
                        <Flex flex={1} flexDirection={'row'} key={`${query.name}_p_${x.name}`} fontSize={'13px'}>
                          <Text mr={2}>{x.name}:</Text>
                          <Text mr={3}>
                            {x.isList ? 'Array<' : ''}
                            {x.namedType}
                            {x.isList ? '>' : ''}
                          </Text>
                          <Text color="red">{x.required ? 'Required' : ''}</Text>
                        </Flex>
                      );
                    })}
                  </Flex>
                </>
              )}
            <Text fontWeight={500} fontSize={'14px'}>
              Response:
            </Text>
            <Flex flex={1} flexDirection={'column'} pl={3}>
              {!returnType ? (
                <Text>{query.namedType}</Text>
              ) : (
                <>
                  {returnType.fields.map((x) => {
                    return (
                      <Flex flex={1} flexDirection={'row'} key={`${query.name}_r_${x.name}`} fontSize={'13px'}>
                        <Text mr={2}>{x.name}:</Text>
                        <Text mr={3}>
                          {x.isList ? 'Array<' : ''}
                          {x.namedType}
                          {x.isList ? '>' : ''}
                        </Text>
                        <Text color="red">{x.required ? 'Required' : ''}</Text>
                      </Flex>
                    );
                  })}
                </>
              )}
            </Flex>
          </Flex>
        )}
      </Flex>
    </Card>
  );
};
const Queries = ({ queries, types }) => {
  if (!queries) return null;

  return (
    <Flex flexDirection={'column'}>
      <Text fontSize={'18px'} fontWeight={600} mb={4}>
        Queries
      </Text>
      {queries.map((q) => {
        return <QueryRow query={q} types={types} key={q.name} />;
      })}
    </Flex>
  );
};

const AdminSc = () => {
  return (
    <Container>
      <Flex mb={4}>
        <Heading flex={1}>SCHEMA</Heading>
      </Flex>

      <Query query={GET_ADMIN_SCHEMA}>
        {({ data, loading }) => {
          if (loading) return null;
          // console.log(data);
          return (
            <>
              <Queries queries={data.getAdminSchema.queries} types={data.getAdminSchema.types} />
            </>
          );
        }}
      </Query>
    </Container>
  );
};

export default AdminSc;
